export default __webpack_public_path__ + "static/media/profile.16fd3c11.jpg";